/**
 * The filled heart's red, shared with `burst-heart.json`.
 *
 * The animation settles on this exact colour, so the static icon has to match it or the heart
 * changes colour the instant the animation hands back. Matches the iOS card's `AppColor`
 * equivalent — both platforms draw the same heart.
 */
const WISHLISTED_FILL = "#E32469";

/**
 * The property card wishlist heart used by the native apps — a bare heart laid over the
 * card image, rather than the web's heart-inside-a-white-circle.
 *
 * Same artwork as the iOS app's `ShortlistHeartShape` (Wishlist.svg, 23x21 viewBox): a
 * translucent black fill with a white stroke so it reads on any photo, turning solid red
 * once wishlisted. The path is inset by the half stroke width, so it needs no extra padding.
 */
const WishlistHeartIcon = ({
  size = 23,
  wishlisted = false,
}: {
  size?: number;
  wishlisted?: boolean;
}) => (
  <svg
    width={size}
    height={(size * 21) / 23}
    viewBox="0 0 23 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5 19.75C16.875 16.0864 22.25 11.5867 22.25 6.16838C22.25 4.78124 21.7255 3.39492 20.6759 2.3368C19.6262 1.27945 18.251 0.75 16.875 0.75C15.4998 0.75 14.1238 1.27945 13.0749 2.3368L11.5 3.92438L9.92587 2.3368C8.87625 1.27945 7.50097 0.75 6.125 0.75C4.74977 0.75 3.37377 1.27945 2.32488 2.3368C1.27522 3.39492 0.75 4.78124 0.75 6.16838C0.75 11.5867 6.125 16.0864 11.5 19.75Z"
      fill={wishlisted ? WISHLISTED_FILL : "black"}
      fillOpacity={wishlisted ? 1 : 0.5}
      stroke="white"
      strokeWidth="1.5"
    />
  </svg>
);

export default WishlistHeartIcon;
